import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettingService } from "./app-setting.service";
import { AppRouterService } from "./app-router.service";
import { PromptService } from "./prompt.service";
import { LoginInfoService } from "./login-info.service";
import { observable, Observable } from "rxjs";
import { UploadFile } from "ng-zorro-antd";
import { ActivatedRoute } from "@angular/router";

@Injectable()
export class HttpRequestService {
  constructor(
    private http: HttpClient,
    private loginInfoService: LoginInfoService,
    private appsettingService: AppSettingService,
    private appRouteService: AppRouterService,
    private promptService: PromptService,
    private activeRouter: ActivatedRoute
  ) { }

  private _httpRequest(requestInfo, requestModel) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post(
      requestInfo.url,
      JSON.stringify(requestModel),
      httpOptions
    );
  }

  private _jsonRequest(requestInfo, requestModel) {
    var file = `assets/data/${requestModel.action.toLowerCase()}/${requestModel.method.toLowerCase()}.json`;
    return this.http.get(file);
  }

  private httpAdapter(action: string, method: string, args: any = null) {
    if (!window["actions"])
      window["actions"] = [];
    if (window["actions"].indexOf(action.toLocaleLowerCase()) == -1)
      window["actions"].push(action.toLocaleLowerCase());
    var requestInfo = this.appsettingService.getRequestInfoByAction(action);
    var requestModel = {
      action: action,
      method: method,
      service: requestInfo.service,
      keyCode: this.loginInfoService.getKeyCodeByPageUrl(
        this.appsettingService.getPrintUrl() +
        this.activeRouter.snapshot["_routerState"].url
      ),
      loginToken: this.loginInfoService.getLoginInfo().loginToken,
      loginUser: this.loginInfoService.getLoginInfo().loginUser,
    };
    if (args != null) {
      for (var arg in args) {
        requestModel[arg] = args[arg];
      }
    }
    //如果使用debug数据并且是本地请求，采用json请求方式
    if (
      this.appsettingService.useDebugData() &&
      requestInfo.service === "local"
    ) {
      return this._jsonRequest(requestInfo, requestModel);
    } else {
      return this._httpRequest(requestInfo, requestModel);
    }
  }

  public httpRequest(
    action: string,
    method: string,
    args: any = null,
    loadingMsg: string = null
  ) {
    return new Observable((observer) => {
      const successHandler = (e) => observer.next(e);
      const errorHandler = (e) => observer.error(e);
      if (loadingMsg != null)
        this.promptService.showloading(loadingMsg, false).subscribe();
      this.httpAdapter(action, method, args).subscribe(
        (result: HttpResult<any>) => {
          if (loadingMsg != null) this.promptService.closeloading();
          if (result != null) {
            if (result.code == 10) {
              if (window.top.hasOwnProperty("overtimeHandler")) {
                window.top["overtimeHandler"]();
              } else {
                this.promptService
                  .error("登录过期，请重新登录")
                  .subscribe(() => {
                    this.appRouteService.goto(["/"]);
                  });
              }
              return;
            }
            if (result.code == 11) {
              result.message = "没有访问权限:" + action + "/" + method;
              this.promptService.toast(result.message, 1000);
              console.log(result.message);
            }
            if (result.code == 14) {
              if (window.top.hasOwnProperty("offlineHandler")) {
                window.top["offlineHandler"](result.message);
              } else {
                this.promptService.error(result.message).subscribe(() => {
                  this.appRouteService.goto(["/"]);
                });
              }
              return;
            }
            successHandler(result);
          } else {
            this.promptService.toast("请求成功，但是没有返回数据", 500);
            errorHandler("请求成功，但是没有返回数据");
          }
        },
        (error) => {
          this.promptService.toast("请求出错,网络错误", 500);
          if (loadingMsg != null) this.promptService.closeloading();
          errorHandler(error);
        }
      );
    });
  }

  /**
   * 请求海康平台接口
   * @param uri 接口地址
   * @param body 请求体
   * @returns 
   */
  public httpRequestToHk(uri: string, body: any) {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZSI6WyJzY29wZSJdLCJleHAiOjE2MzEyOTkwNzIsImp0aSI6IlVqRFpCdm10YTlCeVNzRjFrelFERGNfMGhFMCIsImNsaWVudF9pZCI6IjI5MDcwNTQ3In0.5-NtWOuGR6B0umpsB5pVz_ZKU02sGVBgyB1PfGPirHE",
      }),
    };
    var gateway = this.appsettingService.getHaiKangGatewayUrl();
    return new Observable((observer) => {
      this.http.post(gateway + uri, body, httpOptions).subscribe((reuslt: any) => {
        if (reuslt.code != 0) {
          this.promptService.toast("请求出错,返回码为:" + reuslt.code, 1000);
        }
      }, (error) => {
        console.log(error);
        this.promptService.toast("请求出错,网络错误", 1000);
      });
    })

  }

  public uploadFile(
    action: string,
    method: string,
    file: UploadFile,
    args = null
  ) {
    return new Observable((observer) => {
      const successHandler = (e) => observer.next(e);
      const errorHandler = (e) => observer.error(e);
      this._uploadFile(action, method, file, args).subscribe(
        (result: HttpResult<any>) => {
          if (result != null) {
            if (result.code == 10) {
              if (window.top.hasOwnProperty("overtimeHandler")) {
                window.top["overtimeHandler"]();
              } else {
                this.promptService
                  .error("登录过期，请重新登录")
                  .subscribe(() => {
                    this.appRouteService.goto(["/"]);
                  });
              }
              return;
            }
            if (result.code == 11) {
              this.promptService.toast("没有访问权限," + action + "/" + method);
              return;
            }
            successHandler(result);
          } else {
            this.promptService.toast("请求成功，但是没有返回数据", 500);
            errorHandler("请求成功，但是没有返回数据");
          }
        },
        (error) => {
          this.promptService.toast("请求出错,网络错误", 500);
          errorHandler(error);
        }
      );
    });
  }

  private _uploadFile(
    action: string,
    method: string,
    file: UploadFile,
    args: any = null
  ) {
    var formdata = new FormData();
    var requestInfo = this.appsettingService.getRequestInfoByAction(action);
    var requestModel = {
      action: action,
      method: method,
      service: requestInfo.service,
      keyCode: this.loginInfoService.getKeyCodeByPageUrl(
        this.appsettingService.getPrintUrl() +
        this.activeRouter.snapshot["_routerState"].url
      ),
      loginToken: this.loginInfoService.getLoginInfo().loginToken,
      loginUser: this.loginInfoService.getLoginInfo().loginUser,
    };

    if (args != null) {
      for (var arg in args) {
        requestModel[arg] = JSON.stringify(args[arg]);
      }
    }
    for (var key in requestModel) {
      formdata.append(key, requestModel[key]);
    }

    formdata.append("playloadfile", file as any, file.name);
    return this.http.post(requestInfo.url, formdata);
  }
}

/*
    http请求返回模型
*/
export class HttpResult<T> {
  code: number;
  message: string;
  data: T;
}
